import { render, staticRenderFns } from "./mDataView.vue?vue&type=template&id=7721be2b&scoped=true"
import script from "./mDataView.vue?vue&type=script&lang=js"
export * from "./mDataView.vue?vue&type=script&lang=js"
import style0 from "./mDataView.vue?vue&type=style&index=0&id=7721be2b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7721be2b",
  null
  
)

export default component.exports